function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.991,
    height: 24,
    viewBox: "0 0 19.991 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "09-timer"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59592",
    d: "M25.262 7.141 26.7 5.7l-1.415-1.409-1.536 1.536A9.932 9.932 0 0 0 19 4.048V2h2V0h-6v2h2v2.048a9.932 9.932 0 0 0-4.754 1.779l-1.54-1.536L9.292 5.7l1.436 1.436a10 10 0 1 0 14.534 0zM18 21.99a8 8 0 1 1 8-8 8 8 0 0 1-8 8z",
    style: {
      fill: "#807bff"
    },
    transform: "translate(-8)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59593",
    d: "M30 32v6h-6a6 6 0 1 0 6-6z",
    transform: "translate(-20.002 -24.004)",
    style: {
      fill: "#807bff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer2);
export default __webpack_public_path__ + "static/media/timer-2.20f15ad2ef779c25726588c2f3b6329d.svg";
export { ForwardRef as ReactComponent };